import { string } from 'yup';

export const PASSWORD_MIN_LENGTH = 8;

export type PasswordRequirement = {
  key: 'uppercase' | 'lowercase' | 'number' | 'specialChar' | 'minLength';
  test: (value: string) => boolean;
  messageKey: string;
};

export const passwordRequirements: PasswordRequirement[] = [
  {
    key: 'uppercase',
    test: (value) => /[A-Z]/.test(value),
    messageKey: 'formValidation.passUppercase',
  },
  {
    key: 'lowercase',
    test: (value) => /[a-z]/.test(value),
    messageKey: 'formValidation.passLowercase',
  },
  {
    key: 'number',
    test: (value) => /\d/.test(value),
    messageKey: 'formValidation.passNumber',
  },
  {
    key: 'specialChar',
    test: (value) => /[^A-Za-z0-9]/.test(value),
    messageKey: 'formValidation.passSpecialChar',
  },
  {
    key: 'minLength',
    test: (value) => value.length >= PASSWORD_MIN_LENGTH,
    messageKey: 'formValidation.passMinLength',
  },
];

export const passwordSchema = (t: (key: string) => string) => {
  let schema = string().required(
    t('attributes.password') + ' ' + t('formValidation.fieldRequired')
  );

  passwordRequirements.forEach(({ messageKey, test }) => {
    schema = schema.test(
      messageKey,
      t(messageKey),
      (value) => !!value && test(value)
    );
  });

  return schema;
};
